var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { attrs: { id: "navigationPlaceholder" } }),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _setup.model
          ? _c("div", { staticClass: "col-lg-12" }, [
              !_setup.error
                ? _c("div", { staticStyle: { margin: "30px" } }, [
                    _c(
                      "div",
                      [
                        _c("h1", { staticClass: "text-center" }, [
                          _vm._v("Multiple Management Board"),
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "text-center" }, [
                          _vm._v("Board Advisor Rating Report"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "lead" }, [
                          _c("strong", [_vm._v("Name:")]),
                          _vm._v(" " + _vm._s(_setup.personName)),
                          _c("br"),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Ranking:")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_setup.ranking))]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Score:")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_setup.score))]),
                        ]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Rating profile"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _setup.ratingProfile
                          ? _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-bordered table-hover",
                                },
                                [
                                  _c("thead", [
                                    _c(
                                      "tr",
                                      _vm._l(
                                        _setup.ratingProfile.Header.Headers,
                                        function (header) {
                                          return _c(
                                            "th",
                                            { staticClass: "text-center" },
                                            [_vm._v(_vm._s(header))]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _setup.ratingProfile.Rows,
                                      function (row) {
                                        return _c(
                                          "tr",
                                          _vm._l(row.Values, function (val) {
                                            return _c(
                                              "td",
                                              { staticClass: "text-center" },
                                              [_vm._v(_vm._s(val))]
                                            )
                                          }),
                                          0
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Board Ranking"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            { staticClass: "table table-bordered table-hover" },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(
                                    _setup.boardRanking.Header.Headers,
                                    function (header) {
                                      return _c(
                                        "th",
                                        { staticClass: "text-center" },
                                        [_vm._v(_vm._s(header))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _setup.boardRanking.Rows,
                                  function (row) {
                                    return _c(
                                      "tr",
                                      _vm._l(row.Values, function (val) {
                                        return _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(val))]
                                        )
                                      }),
                                      0
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Individual's Rating Over Time"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            { staticClass: "table table-bordered table-hover" },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(
                                    _setup.ratingOverTime.Header.Headers,
                                    function (header) {
                                      return _c(
                                        "th",
                                        { staticClass: "text-center" },
                                        [_vm._v(_vm._s(header))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _setup.ratingOverTime.Rows,
                                  function (row) {
                                    return _c(
                                      "tr",
                                      _vm._l(row.Values, function (val) {
                                        return _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(val))]
                                        )
                                      }),
                                      0
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v("Overall Board Scoring Statistics"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("table", [
                          _c("tr", [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_setup.totalPossibleScore)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_setup.boardHighScore)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_setup.boardAverage)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            { staticClass: "table table-bordered table-hover" },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(
                                    _setup.overallBoardScoringStatistics.Header
                                      .Headers,
                                    function (header) {
                                      return _c(
                                        "th",
                                        { staticClass: "text-center" },
                                        [_vm._v(_vm._s(header))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _setup.overallBoardScoringStatistics.Rows,
                                  function (row) {
                                    return _c(
                                      "tr",
                                      _vm._l(row.Values, function (val) {
                                        return _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(val))]
                                        )
                                      }),
                                      0
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _setup.criteriaVotes.length
                          ? _c("h3", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n                            Comments for " +
                                  _vm._s(_setup.personName) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_setup.criteriaVotes, function (criterionVotes) {
                          return [
                            _c("h4", [
                              _vm._v(_vm._s(criterionVotes.CriterionPath)),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-bordered table-hover",
                                },
                                [
                                  _vm._m(3, true),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      criterionVotes.Votes,
                                      function (vote) {
                                        return _c("tr", [
                                          _c("td", [
                                            _vm._v(_vm._s(vote.EvaluatorName)),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [_vm._v(_vm._s(vote.Value))]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(vote.Comment)),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        }),
                      ],
                      2
                    ),
                  ])
                : _c("div", { staticStyle: { margin: "30px" } }, [
                    _c("h1", [_vm._v(_vm._s(_setup.error))]),
                  ]),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("strong", [_vm._v("Total Possible Score:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("strong", [_vm._v("Board High Score:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("strong", [_vm._v("Board Average:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Evaluator")]),
        _vm._v(" "),
        _c("th", [_vm._v("Score")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comment")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }